import { useDrag } from '@use-gesture/react';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import { useSpring } from 'react-spring';

// Components
import { Button } from 'antd';

import {
    ActionList,
    Body,
    Container,
    DraggableElement,
    FileSearchOutlinedIcon,
    FinishButton,
    Header,
    LeftOutlinedIcon,
    Title,
} from 'top-component-library/PreviewBanner/styles';

function PreviewAlert() {
  const [expanded, setExpanded] = useState(false);
  const [{ x, y }, api] = useSpring(() => ({ x: 0, y: 0 }));
  const dragContainer = useRef();

  const viewingInIframe = window.location !== window.parent.location;

  const bind = useDrag(
    ({ offset }) => {
      api.set({
        x: offset[0],
        y: offset[1],
      });
    },
    {
      from: () => [x.get(), y.get()],
    }
  );

  const handleFinishPreviewing = (): void => {
    window.location.replace(`${window.location.origin}${window.location.pathname}?hostname=`);
  };

  return (
    <DraggableElement {...bind()} style={{ x, y }} ref={dragContainer}>
      <Container>
        <Header>
          <span>
            <FileSearchOutlinedIcon />
            <Title level={5}>Preview Mode</Title>
          </span>
          <Button type="link" onClick={() => setExpanded(!expanded)}>
            <LeftOutlinedIcon data-expanded={expanded} />
          </Button>
        </Header>
        <Body data-expanded={expanded}>
          <ul>
            <li>While in preview mode you can view edits before publishing.</li>
            {viewingInIframe && (
              <li>
                <b>Note:</b> Checkout is blocked when viewing the branded ordering site in the BOS builder.
              </li>
            )}
          </ul>
        </Body>
        <ActionList data-expanded={expanded}>
          {!viewingInIframe && (
            <FinishButton type="link" onClick={handleFinishPreviewing}>
              Finish
            </FinishButton>
          )}
        </ActionList>
      </Container>
    </DraggableElement>
  );
}

export default observer(PreviewAlert);
